<template>
    <div>

        <el-row>
            <div class="left-justifying"><h3>绩效公示</h3></div>
        </el-row>

        <div class="panel">
            <div class="panel-body">

                <el-row>
                    <div class="advanced-search-location">
                        <AthubDropDownSearch :model="searchParams" :formWidth="800" v-if="true" size="mini" collapseTags
                                             multiple>
                            <el-form :model="searchParams" label-width="80px">
                                <el-row v-show="false" type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="数据中心">
                                            <dept-select size="mini"
                                                         :allowAll=false
                                                         :multiple=false
                                                         v-model="searchParams.kpiDto.deptid">
                                            </dept-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="开始月份">
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchParams.kpiDto.startdate"
                                                    type="month"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="结束月份">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="结束月份">
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchParams.kpiDto.enddate"
                                                    type="month"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="结束月份">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </AthubDropDownSearch>
                    </div>

                    <el-tabs v-model="activeTab">
                        <el-tab-pane label="" name="table_tab">
                            <el-row class="bottom20">
                                <el-table :data="kpiResultPageInfo.tableData" stripe style="width: 100%">
                                    <el-table-column :formatter="formatDept" label="数据中心">
                                        <template slot="header" slot-scope="scope">
                                            数据中心<br>
                                            <dept-select size="mini"
                                                         :allowAll=false
                                                         :multiple=false
                                                         v-model="searchParams.kpiDto.deptid">
                                            </dept-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="realname" label="姓名">
                                        <template slot="header" slot-scope="scope">
                                            姓名<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="searchParams.realname"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="titleLevel" label="职级">
                                        <template slot="header" slot-scope="scope">
                                            职级<br><br><br>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="kpiDto.kpidate" :formatter="formatKpiDate" label="考评月份">
                                        <template slot="header" slot-scope="scope">
                                            考评月份<br><br><br>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="score" label="绩效得分">
                                        <template slot="header" slot-scope="scope">
                                            绩效得分<br><br><br>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                </el-row>

                <el-row type="flex" class="row-bg" justify="end">
                    <el-pagination align="right" @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="currentPage"
                                   :page-sizes="pageSizes" :page-size="pageSize"
                                   layout="total, sizes, prev, pager, next, jumper"
                                   :total="kpiResultPageInfo.total">
                    </el-pagination>
                </el-row>

            </div>
        </div>

    </div>
</template>

<script type="text/javascript">

    import DeptSelect from '@/components/dept'
    import AthubDropDownSearch from '@/components/common/athub.dropdown.search'
    import {debounce} from '../../util'
    import { mapState, mapGetters, mapMutations, mapActions, createNamespacedHelpers } from 'vuex';
    import AthubCloudApi from "../../api/athubCloud";

    const kpiResultNSHelper = createNamespacedHelpers( "kpiResult" );
    const deptNSHelper = createNamespacedHelpers( "dept" );

    export default {
        name: 'kpiRecord',

        components: {

            DeptSelect,
            AthubDropDownSearch,

        },

        data() {

            return {

                searchParams: {
                    realname: '',
                    kpiDto: {
                        deptid: null,
                        startdate: '',
                        enddate: '',
                        status: 'CLOSE',
                    }
                },

                //表格翻页查询条件
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],

                //当前Tab页
                activeTab: "table_tab",

                deptInfoArr: [],
            }

        },

        methods: {

            ...kpiResultNSHelper.mapActions([
                'getKpiResultPageInfo',
            ]),

            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
            },

            async queryTable() {

                let pageParams = {
                    'currentPage': this.currentPage,
                    'pageSize': this.pageSize,
                }

                let deptInfo = await AthubCloudApi.fetchDeptListByAuthSites();
                let deptIds = deptInfo.map(e => e.id);

                this.searchParams.kpiPersonList = this.kpiPersonList;
                let params = {...this.searchParams, ...pageParams};
                params.kpiDto.depts = deptIds;

                await this.getKpiResultPageInfo(params);

            },

            formatKpiDate(row, column){
                return new Date(row.kpiDto.kpidate).Format('yyyy-MM');
            },

            formatDept(row, column) {
                let deptDesc = '';
                for (let i = 0; i < this.deptInfoArr.length; i++) {
                    if(row.kpiDto.deptid == this.deptInfoArr[i].id){
                        deptDesc = this.deptInfoArr[i].name;
                        return deptDesc;
                    }
                }
            },

        },

        computed: {
            ...kpiResultNSHelper.mapGetters(['kpiResultPageInfo']),
            ...deptNSHelper.mapGetters(['deptSource$']),
        },

        watch: {

            searchParams: {
                deep: true,
                handler: debounce(function (newVal, oldVal) {
                    this.currentPage = 1;
                    this.kpiResultPageInfo.total = 0;
                    this.kpiResultPageInfo.tableData = [];
                    this.queryTable();
                }, 500)
            },

            pageSize: {
                handler() {
                    this.queryTable();
                },
            },

            currentPage: {
                handler() {
                    this.queryTable();
                },
            },

        },

        mounted() {
            this.deptSource$.subscribe(v => {
                if (v != null && v.length > 0) {
                    this.searchParams.kpiDto.deptid = v[0].id;
                    this.deptInfoArr = v;
                }
            });
        },


    }

</script>